import PropTypes from 'prop-types';
import React from 'react';
import FindAStorePageLazy from '../FindAStorePage/FindAStorePageLazy';
import { findStores } from '../../common/Constants';

const SelectaStore = ({ isGeoStore }) => (
    <FindAStorePageLazy
        theme="selectAStore"
        title={isGeoStore ? findStores.selectAStorePageTitle : findStores.changeMyStorePageTitle}
    />
);

SelectaStore.defaultProps = {
    isGeoStore: false,
};

SelectaStore.propTypes = {
    isGeoStore: PropTypes.bool,
};

export default SelectaStore;
